"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownError = void 0;
var React = require("react");
var Error_svg_1 = require("../../assets/icons/Error.svg");
var TooltipEnums_1 = require("../Tooltip/TooltipEnums");
var Tooltip_1 = require("../Tooltip");
var constants_1 = require("./constants");
var DropdownError_st_css_1 = require("./DropdownError.st.css");
exports.DropdownError = function (_a) {
    var className = _a.className, errorMessage = _a.errorMessage, _b = _a.placement, placement = _b === void 0 ? 'top-end' : _b;
    return (React.createElement(Tooltip_1.Tooltip, { className: DropdownError_st_css_1.st(DropdownError_st_css_1.classes.root, className), "data-hook": constants_1.DATA_HOOKS.errorTooltip, placement: placement, skin: TooltipEnums_1.TooltipSkin.Error, content: errorMessage },
        React.createElement(Error_svg_1.ReactComponent, { width: constants_1.ICON_SIZE, height: constants_1.ICON_SIZE })));
};
//# sourceMappingURL=DropdownError.js.map